import React, { useCallback, useEffect, useState, useRef } from "react";
import styled, { withTheme } from "styled-components";
import ContentEditable from "react-contenteditable";
import { useDebounce } from "use-lodash-debounce";

import { Wrapper } from "./styled.js";
import Button from "../Button";

export default withTheme((props) => {
  const { extra = {}, theme, save, id } = props;
  const {
    label = "No label",
    tagName = "h1",
    textAlign = "left",
    style = {},
    showCancel = true,
    fluid,
    stack,
  } = extra;
  const [value, setValue] = useState(label);
  const debouncedValue = useDebounce(value, 500);

  const didMountRef = useRef(false);

  return (
    <Wrapper stack={stack}>
      {showCancel && (
        <Button builder={true} extra={{ label: "Cancel", fluid }} />
      )}
      <Button builder={true} extra={{ label: "Connection #1", fluid }} />
      <Button builder={true} extra={{ label: "Connection #2", fluid }} />
    </Wrapper>
  );
});
